import React from 'react';
import './MediaItem.css';

function MediaItem({ file, isActive, onPick, showRemove, onRemove, className }) {
    const [cacheBuster, setCacheBuster] = React.useState(Date.now());
    const isPickedClass = isActive ? 'active' : '';
    // Determine if this is a selected-media or a library item
    const isSelected = className && className.includes('selected-media');

    // Handle image rotation
    const handleRotate = (e) => {
        e.stopPropagation(); // Prevent triggering onPick

        // Send a POST request to rotate the image
        fetch(`/account/media/${file.uuid}/rotate`, {
            method: 'POST',
            credentials: 'same-origin', // Include cookies
            headers: {
                'Content-Type': 'application/json'
            },
            // add random data to prevent caching
            body: JSON.stringify({
                timestamp: new Date().getTime()
            })
        })
        .then(response => {
            if (response.ok) {
                // Force reload of the image by adding/updating a timestamp parameter const timestamp = new Date().getTime();
                setCacheBuster(Date.now());
            } else {
                console.error('Failed to rotate image');
            }
        })
        .catch(error => {
            console.error('Error rotating image:', error);
        });
    };

    // Determine if this is an image that can be rotated (not PDF or video)
    const canRotate = file.mimetype && file.mimetype.startsWith('image/');

    return (
        <div
            className={`media-item ${isPickedClass} ${className || ''}`}
            data-id={file.id}
            data-uuid={file.uuid}
            onClick={onPick ? () => onPick(file.id) : undefined}
        >
            {isSelected ? (
                file.mimetype === 'application/pdf' ? (
                    <figure>
                        <i className="far fa-file-pdf"></i>
                        <figcaption>{file.filename}</figcaption>
                    </figure>
                ) : file.mimetype?.substring(0, 5) === 'video' ? (
                    <figure>
                        <i className="far fa-file-video"></i>
                        <figcaption>{file.filename}</figcaption>
                    </figure>
                ) : file.mimetype?.substring(0, 5) === 'image' ? (
                    <div className="selected-image-container">
                        <a href={`/account/media/${file.uuid}`} target="_blank" rel="noopener noreferrer" title="Edit image in new tab">
                            <img src={`${file.cdnUrl}?w=100&cb=${cacheBuster}`} alt={file.title} />
                        </a>
                        {canRotate && (
                            <button
                                className="rotate-button"
                                onClick={handleRotate}
                                title="Rotate image 90° clockwise"
                            >
                                <i className="fas fa-redo"></i>
                            </button>
                        )}
                    </div>
                ) : (
                    <figure>
                        <i className="far fa-file"></i>
                        <figcaption>{file.filename}</figcaption>
                    </figure>
                )
            ) : (
                <>
                    <div
                        className="preview"
                        style={{ backgroundImage: file.mimetype === 'application/pdf' || file.mimetype?.startsWith('video') ? undefined : `url('${file.cdnUrl}?w=360&h=300&cb=${cacheBuster}')` }}
                    >
                        {file.mimetype === 'application/pdf' ? (
                            <i className="far fa-file-pdf icon-color-danger" style={{ fontSize: 48, margin: '0.5em' }}></i>
                        ) : file.mimetype?.startsWith('video') ? (
                            <i className="far fa-file-video icon-color-info" style={{ fontSize: 48, margin: '0.5em' }}></i>
                        ) : file.mimetype?.startsWith('image') ? (
                            <>
                                <img style={{ display: 'none' }} src={`${file.cdnUrl}?w=360&h=300&cb=${cacheBuster}`} alt={file.title} />
                                {canRotate && (
                                    <button
                                        className="rotate-button"
                                        onClick={handleRotate}
                                        title="Rotate image 90° clockwise"
                                    >
                                        <i className="fas fa-redo"></i>
                                    </button>
                                )}
                            </>
                        ) : (
                            <i className="far fa-file text-muted" style={{ fontSize: 48, margin: '0.5em' }}></i>
                        )}
                    </div>
                    <div className="info">
                        <h3>
                            <a href={`/account/media/${file.uuid}`}>{file.title || file.filename}</a>
                        </h3>
                        {file.description && <p>{file.description}</p>}
                        {file.createdAt && <p>{file.createdAt}</p>}
                    </div>
                </>
            )}
            {showRemove && (
                <a className="button remove-value" onClick={e => { e.stopPropagation(); onRemove && onRemove(); }}>Remove Current</a>
            )}
        </div>
    );
}

export default MediaItem;
